import React from 'react';

const Link = ({stroke}) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.9375 5.9375H4.875C4.44402 5.9375 4.0307 6.1087 3.72595 6.41345C3.4212 6.7182 3.25 7.13152 3.25 7.5625V14.875C3.25 15.306 3.4212 15.7193 3.72595 16.024C4.0307 16.3288 4.44402 16.5 4.875 16.5H12.1875C12.6185 16.5 13.0318 16.3288 13.3365 16.024C13.6413 15.7193 13.8125 15.306 13.8125 14.875V10.8125" stroke={stroke} stroke-width="2.0625" strokeLinecap="round" stroke-linejoin="round"/>
      <path d="M8.12476 11.625L16.2498 3.5" stroke={stroke} stroke-width="2.0625" strokeLinecap="round" stroke-linejoin="round"/>
      <path d="M12.1875 3.5H16.2509V7.5634" stroke={stroke} stroke-width="2.0625" strokeLinecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default Link;